'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TiDirections = function TiDirections(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm34.8 15.8l-4.5-4.3c-1-0.9-2.5-1.5-3.8-1.5h-4.8v-0.8c0-1.4-1.2-2.5-2.5-2.5s-2.5 1.1-2.5 2.5v0.8h-5.9c-3.2 0-5.8 2.6-5.8 5.8 0 2.4 1.4 4.4 3.4 5.3l-3.1 3.1 4.3 4.2c0.9 1 2.4 1.6 3.7 1.6h3.7l1.3 6.7h1.7l1.3-6.7h4.5c3.3 0 5.9-2.6 5.9-5.8 0-1.5-0.6-2.9-1.6-3.9 0.1-0.1 0.1-0.1 0.2-0.1l4.5-4.4z m-9 10.9h-12.5c-0.4 0-1.1-0.3-1.4-0.6l-1.9-1.9 1.9-1.9c0.3-0.4 1-0.6 1.4-0.6h12.5c1.4 0 2.5 1.1 2.5 2.5s-1.1 2.5-2.5 2.5z m2.2-8.9c-0.4 0.3-1 0.5-1.5 0.5h-15.7c-1.3 0-2.5-1.1-2.5-2.5s1.2-2.5 2.5-2.5h15.7c0.5 0 1.1 0.3 1.5 0.6l2 1.9-2 2z' })
        )
    );
};

exports.default = TiDirections;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/ti/directions.js
// module id = 3576
// module chunks = 0